export const transformVersionNum = version => {
  return Number(String(version).replace(/\./gim, ''))
}

export function jsonEncode(data) {
  return JSON.stringify(data)
}

export function jsonDecode(data) {
  return JSON.parse(data)
}

export const getLocal = key => {
  let data = localStorage.getItem(key) || '""'
  return jsonDecode(data)
}

export const removeLocal = key => {
  localStorage.removeItem(key)
}

export const setLocal = (key, data) => {
  localStorage.setItem(key, jsonEncode(data || ''))
}

export const addDomClass = (targetSelector, className) => {
  document.querySelector(targetSelector).classList.add(className)
}

export const getPlatforms = () => {
  let isAndroid = null
  let isiOS = null
  if (typeof window === 'object') {
    let userAgent = window.navigator.userAgent
    isAndroid =
      userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1
    isiOS =
      !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) ||
      !!userAgent.match(/Macintosh;/i)
  }
  return { isAndroid, isiOS }
}

/**
 *  class: Kwtime
 *  @param    {[date]}   time [时间戳]
 *  @param    {[string]}   format   [时间格式]
 *  format格式包括
 *  1. Y-M-D
 *  2. M/D h:m
 *  3. Y/M/D h:m:s
 *  4. Y年M月D日 h时m分s秒
 *
 *  new Kwtime({
 *    time:4352456823661,
 *    format:'Y年M月D日 h:m:s'
 *  }).formatDate() ==> 2107年12月04日 23:47:03
 */
export class Kwtime {
  constructor({ time, format, zeroFill }) {
    this.time = time
    this.formats = format
    this.zeroFill = zeroFill
  }

  formatDigit(num) {
    return num.toString().replace(/^(\d)$/, this.zeroFill ? '0$1' : '$1')
  }

  formatDate() {
    let formats = this.formats || 'Y-M-D'
    let myDate = this.time ? new Date(this.time) : new Date()
    let year = myDate.getFullYear()
    let month = this.formatDigit(myDate.getMonth() + 1)
    let day = this.formatDigit(myDate.getDate())

    let hour = this.formatDigit(myDate.getHours())
    let minute = this.formatDigit(myDate.getMinutes())
    let second = this.formatDigit(myDate.getSeconds())

    return formats.replace(/Y|M|D|h|m|s/g, function(matches) {
      return {
        Y: year,
        M: month,
        D: day,
        h: hour,
        m: minute,
        s: second
      }[matches]
    })
  }
}

export function formatDate(time, format, zeroFill) {
  return new Kwtime({ time, format, zeroFill }).formatDate()
}

export function kwFormatTime(time) {
  const timeS = new Date(time).getTime()
  const curTimeS = new Date().getTime()
  let minute = 1000 * 60
  let hour = minute * 60
  let day = hour * 24
  let timeStamp = new Date(new Date().setHours(0, 0, 0, 0)).getTime() //当天零点的时间
  let diff = curTimeS - timeS
  let date = Math.floor(diff / day)
  let YMD = formatDate(timeS, 'YMD', false)
  let curYMD = formatDate(curTimeS, 'YMD', false)

  if (timeS < timeStamp) date += 1
  if (curYMD - YMD === 1) date = 'today'

  switch (date) {
    case 0:
      return '今天'
    case 1:
    case 'today':
      return '昨天'
    default:
      return formatDate(timeS, 'M月D日', false)
  }
}

export function getStyle(element, attr) {
  let value
  if (typeof window.getComputedStyle != 'undefined') {
    //W3C
    value = window.getComputedStyle(element, null)[attr]
  } else if (typeof element.currentStyle != 'undeinfed') {
    //IE
    value = element.currentStyle[attr]
  }
  return value
}

export function toFixed(num, intercept) {
  num = parseFloat(num)
  if (!num) return (0).toFixed(intercept)

  let max = 10
  let sbr = max - intercept
  return num.toFixed(max).slice(0, -sbr)
}

export function nonNumeric(value, isReg = false) {
  const Reg = /[^0-9]/gi
  return isReg ? Reg : String(value).replace(Reg, '')
}

export function clearNonNumMoney(value) {
  return String(value)
    .replace(/[^\d.]/g, '')
    .replace(/\.{2,}/g, '.')
    .replace('.', '$#$')
    .replace(/\./g, '')
    .replace('$#$', '.')
    .replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
    .replace(/^\./g, '')
}

export function copyData(data) {
  return jsonDecode(jsonEncode(data))
}

// 求和
export const Summation = arr => {
  if (!Array.isArray(arr)) return 0
  return arr.reduce(function(sum, number) {
    return Number(sum) + Number(number)
  }, 0)
}

export const kScroll = (nd, x = 0, y = 0) => {
  let xv = 0
  x = y > 0 ? y : x
  setTimeout(() => {
    const timer = setInterval(() => {
      xv += Math.ceil(x - xv) / 20
      if (xv >= x) {
        xv = x
        clearInterval(timer)
      }
      nd.scroll.apply(nd, y ? [0, xv] : [xv, 0])
    }, 16)
  }, 200)
}

//app 版本号大小比较
export const versionStringCompare = (preVersion = '', lastVersion = '') => {
  var sources = preVersion.split('.')
  var dests = lastVersion.split('.')
  var maxL = Math.max(sources.length, dests.length)
  var result = 0
  for (let i = 0; i < maxL; i++) {
    let preValue = sources.length > i ? sources[i] : 0
    let preNum = isNaN(Number(preValue))
      ? preValue.charCodeAt()
      : Number(preValue)
    let lastValue = dests.length > i ? dests[i] : 0
    let lastNum = isNaN(Number(lastValue))
      ? lastValue.charCodeAt()
      : Number(lastValue)
    if (preNum < lastNum) {
      result = 0
      break
    } else if (preNum > lastNum) {
      result = 1
      break
    }
  }
  return result
}
/**
  * 将省市区三个数组封装成级联组件省市区的数组
 [{
   name: '浙江省',
   code: '330000',
   children: [{ name: '杭州市', code: '330100' ,children:[{ name: 'xx区', code: '330101',children: '']}],
 }],
  * @param{Array} province_list 省数组
  * @param{Array} city_list 市数组
  * @param{Array} zones_list 区数组
  * @param{String} objName 省/市/区名字
  * @param{Number|String} objId 省/市/区id
  * @param{Number|String} pid 省id(市数组对象有pid属性关联省级数组的id,用于过滤市级数据)
  * @param{Number|String} cid 市id(区数组对象有cid属性关联市级数组的id,用于过滤区级数据)
  * @param{Object} fieldNames 自定义省市区数据数组对象结构key { text: 'name', value: 'code', children: 'children' }
  */
export function filterAreaData(
  province_list = [],
  city_list = [],
  zones_list = [],
  objName = 'n',
  objId = 'id',
  pid,
  cid,
  fieldNames
) {
  let allArea = []
  // fieldNames这个是封装对象结构属性的key, 有传值就用传的值，没有就使用默认的fieldNames的值
  // 级联省市区数据数组对象结构key参照如下
  fieldNames = fieldNames || {
    text: 'name',
    value: 'code',
    children: 'children'
  }
  allArea = province_list.map(province => {
    let obj = {
      [fieldNames.text]: province[objName],
      [fieldNames.value]: province[objId],
      [fieldNames.children]: []
    }
    city_list.forEach(city => {
      if (city[pid] === province[objId]) {
        obj.children.push({
          [fieldNames.text]: city[objName],
          [fieldNames.value]: city[objId],
          [fieldNames.children]: []
        })
        zones_list.forEach(zone => {
          if (zone[cid] === city[objId]) {
            obj.children[obj.children.length - 1].children.push({
              [fieldNames.text]: zone[objName],
              [fieldNames.value]: zone[objId],
              [fieldNames.children]: ''
            })
          }
        })
      }
    })
    return obj
  })
  return allArea
}

/**
 * 过滤字符串所有空格
 * @param {*} val 值
 * @param {*} replaceText 空格替换的值
 * @returns
 */
export function filterEmpty(val, replaceText = '') {
  val = val && val.replace(/\s+/g, replaceText)
  return val
}
// 防抖
export function _debounce(fn, delay) {
  var delay = delay || 200
  var timer
  return function() {
    var th = this
    var args = arguments
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(function() {
      timer = null
      fn.apply(th, args)
    }, delay)
  }
}
//使用方式
//  button @click= toFinish（type）
//   toFinish: _throttle(function(type) {
//     this.$bridge.completeNewUserTask(type)
//   }, 1000),
// 节流
export function _throttle(fn, interval) {
  var last
  var timer
  var interval = interval || 200
  return function() {
    var th = this
    var args = arguments
    var now = +new Date()
    if (last && now - last < interval) {
      clearTimeout(timer)
      timer = setTimeout(function() {
        last = now
        fn.apply(th, args)
      }, interval)
    } else {
      last = now
      fn.apply(th, args)
    }
  }
}

export function isIphonex() {
  if (typeof window !== 'undefined' && window) {
    return (
      /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812
    )
  }
  return false
}

export function verifyPhone(phone) {
  return /^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(phone)
}
// 真实姓名校验
export function verifyRealName(name) {
  return /^(?:(?!先生|小姐|男士|女士)[\u2E80}-\ufe4f]){2,30}$/.test(name)
}
// 身份证号校验
export function verifyPatientIdCard(idCard) {
  return /^\d{6}((((((19|20)\d{2})(0[13-9]|1[012])(0[1-9]|[12]\d|30))|(((19|20)\d{2})(0[13578]|1[02])31)|((19|20)\d{2})02(0[1-9]|1\d|2[0-8])|((((19|20)([13579][26]|[2468][048]|0[48]))|(2000))0229))\d{3})|((((\d{2})(0[13-9]|1[012])(0[1-9]|[12]\d|30))|((\d{2})(0[13578]|1[02])31)|((\d{2})02(0[1-9]|1\d|2[0-8]))|(([13579][26]|[2468][048]|0[048])0229))\d{2}))(\d|X|x)$/.test(
    idCard
  )
}

// 手机正则校验
export function verifyMobile(mobile) {
  return /^(19[0-9]|13[0-9]|15[0-9]|166|17[0-9]|18[0-9]|14[0-9])[0-9]{8}$/.test(
    mobile
  )
}
// 银行卡的校验
export function verifyBankCard(cardNumber) {
  return /^[1-9]\d{12,18}$/.test(cardNumber)
}
